/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// console.log(
//     '%cGOHY',
//     'color: #ffff; background: #1A4091; padding: 25px 25px 25px 25px; font-size: 75px',
// );

// const script = document.createElement('script');
// script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
// script.async = true;
// document.head.appendChild(script);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
